import { inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { DefaultOAuthInterceptor } from 'angular-oauth2-oidc';

import { FormDeactiviationGuard } from '@app/shared/route-guards/form-deactivateable/form-deactiviation.guard';
import { ApiUrlService } from '@app/shared/services/api-url.service';
import { ForbiddenService } from '@app/shared/services/forbidden.service';
import { ITenantService } from '@app/shared/services/itenant.service';
import { TenantService } from '@app/shared/services/tenant.service';
import { UsersService } from '@app/shared/services/users.service';

import { AuthenticationGuard } from './authentication/authentication.guard';
import { AuthorizationInterceptor } from './http/authorization.interceptor';
import { ErrorHandlerInterceptor } from './http/error-handler.interceptor';
import { HttpCacheService } from './http/http-cache.service';
import { registerHypecastIcons } from './icon-registry';
import { I18nService } from './i18n.service';
import { RouteReusableStrategy } from './route-reusable-strategy';

/**
 * Explicit root providers for the standalone application shell.
 *
 * Legacy CoreModule side effects have been removed. SVG icon registration is
 * now an explicit application initializer and HTTP is configured separately
 * through provideHttpClient() in app.config.ts.
 */
export function provideHypecastCore() {
  return makeEnvironmentProviders([
    { provide: ITenantService, useClass: TenantService },
    ApiUrlService,
    ForbiddenService,
    FormDeactiviationGuard,
    DefaultOAuthInterceptor,
    AuthorizationInterceptor,
    AuthenticationGuard,
    HttpCacheService,
    UsersService,
    ErrorHandlerInterceptor,
    I18nService,
    { provide: RouteReuseStrategy, useClass: RouteReusableStrategy },
    provideAppInitializer(() => {
      registerHypecastIcons(inject(MatIconRegistry), inject(DomSanitizer));
    }),
  ]);
}
